'use client';

import { SeoReviewItem } from '@actr/stores/src/stores/models/seo/review';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { Carousel } from '@actr/ui/src/components/carousel';
import { SlideImgObjectFit } from '@actr/ui/src/components/carousel/specs';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import React, { memo, useState } from 'react';

import ModalsGroup from '@/components/reviews/modals';
import Review from '@/components/reviews/review';

import * as Styled from './style.css';

export type ReviewsBlockProps = {
  title: string;
  feedback: SeoReviewItem[] | null;
  isCarouselView?: boolean;
}

const ReviewsBlock: React.FC<ReviewsBlockProps> = ({ feedback, title, isCarouselView }) => {
  const [isShowAddReviewModal, setShowAddReviewModal] = useState(false);

  if (!feedback?.length) {
    return null;
  }

  function handleAddReview() {
    setShowAddReviewModal(true);
  }

  function renderDesktopReviews() {
    return (
      <div className={Styled.ReviewsWrapper}>
        {feedback?.map((item, i) => (
          <Review
            key={i}
            review={item.review}
            rating={item.rating}
            user={item.user}
            date={item.date}
            answer={item.answer}
            isReviewsPage={false}
          />
        ))}
      </div>
    );
  }

  function renderCarousel() {
    if (!feedback) {
      return null;
    }
    return (
      <Carousel
        items={feedback.map((item, i) => (
          <Review
            key={i}
            review={item.review}
            rating={item.rating}
            user={item.user}
            date={item.date}
            answer={item.answer}
            isReviewsPage={false}
          />
        ))}
        imgObjectFit={SlideImgObjectFit.NONE}
        withBorder={false}
        slideClassName={Styled.CarouselSlide}
        slidesPerViewBreakPoints={{
          0: {
            slidesPerView: 'auto',
            spaceBetween: 16,
          },
          800: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 8,
          }
        }}
      />
    );
  }

  return (
    <ContentBlock className={Styled.ContentBlock} id="feedback" tagProps={{ itemScope: true, itemType: 'https://schema.org/Organization' }}>
      <Text font="title.x2l" tagName="h3">
        {title}
      </Text>
      <meta itemProp="name" content="Авиакасса" />
      <meta itemProp="telephone" content="+7 (495) 970-17-17" />
      <meta itemProp="address" content="г. Москва, Хорошевское шоссе, 32А" />
      {isCarouselView ? renderCarousel() : renderDesktopReviews()}
      <div className={Styled.AddButtonWrapper}>
        <Button
          className={Styled.Button}
          size={ButtonSizes.M}
          buttonType={ButtonTypes.TERTIARY}
          onClick={handleAddReview}>
          Добавить отзыв
        </Button>
        <a href="/reviews" target="_blank">
          <Button
            className={Styled.Button}
            size={ButtonSizes.M}
            buttonType={ButtonTypes.GHOST}>
            Все отзывы
          </Button>
        </a>
      </div>
      <ModalsGroup isShowAddReviewModal={isShowAddReviewModal} setShowAddReviewModal={setShowAddReviewModal} />
    </ContentBlock>
  );
};
export default memo(ReviewsBlock);
